import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPadre = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'padre',
        name: 'Padre',
        component: ViewPadre,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
